import { render, staticRenderFns } from "./PensionAjout.vue?vue&type=template&id=6f8857e2&"
import script from "./PensionAjout.vue?vue&type=script&lang=js&"
export * from "./PensionAjout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports